import React from 'react'
import PropTypes from 'prop-types';
import classNames from 'classnames'
import style from './LabelGroup.css';

export default class LabelGroup extends React.Component {
  
  render() { 
    const { vertical, className, ...rest } = this.props
    const clazz = classNames( className, style.labelGroup, vertical ? style.vertical : null );

    return (
      <div className={clazz} {...rest}>
        {this.props.children}
      </div>
    )
  }
}
